import { alpha, Theme } from '@mui/material';

export default {
    root: {
        '& .MuiSlider-thumb': {
            backgroundColor: 'primary.contrastText',
            border: '2px solid',
            borderColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.8),
            width: '12px',
            height: '12px',
            '&:hover': {
                background: (theme: Theme) => theme.palette.primary.contrastText,
            },
        },
        '& .MuiSlider-track': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.8),
        },
        '& .MuiSlider-rail': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
            border: 'none',
        },
    },
};
